export default __webpack_public_path__ + "static/media/want_more.2e1b7be8.webp";